import HttpApi from '@/utils/HttpApi'
import { getCancelerContainer } from '@/utils/httpCanceler'
import { ImageInterface } from '@/utils/image'

interface Apps {
    apps: AppEntity[]
}

interface App {
    app: AppEntity
}

interface Count {
    count: number
}

export default class AppsApi {
    public static async getApps(params: any) {
        const cancelerContainer = getCancelerContainer('apps')
        const response = await HttpApi.get<Apps>('apps', params, cancelerContainer)
        return response
    }

    public static async getApp(id: number) {
        const cancelerContainer = getCancelerContainer('singleApp')
        const response = await HttpApi.get<App>(`apps/${id}`, null, cancelerContainer)
        return response
    }

    public static async putApp(data: AppEntity) {
        return await HttpApi.put<App>('apps', data)
    }

    public static async postApp(data: AppEntity) {
        return await HttpApi.post<App>('apps', data)
    }

    public static async requestAppUpdate(id: number, request: any) {
        return await HttpApi.post<App>(`apps/${id}/update`, request)
    }

    public static async uploadImagesApp(id: number, images: Map<string, ImageInterface>) {
        const formData = new FormData()
        formData.append('apps_id', (id as any))
        for (const [key, data] of images.entries()) {
            if (data.file !== undefined) {
                formData.append(key, data.file)
            }
        }

        return await HttpApi.upload<null>('apps/images', formData)
    }

    public static async uploadScreenshotsApp(id: number, images: Map<string, ImageInterface[]>) {
        const formData = new FormData()
        for (const [key, data] of images.entries()) {
            data.forEach((image) => {
                if (image.file !== undefined) {
                    formData.append(key, image.file)
                }
            })
        }

        return await HttpApi.upload<null>(`apps/${id}/screenshots`, formData)
    }

    public static async deleteScreenshotsApp(id: number, screeenshotsIds: number[]) {
        const queryString = `?ids=${screeenshotsIds.join(',')}`

        return await HttpApi.delete<null>(`apps/${id}/screenshots${queryString}`, null, undefined, false)
    }

    public static async getBrandById(brandId: number) {
        const cancelerContainer = getCancelerContainer('getBrandById')
        const response = await HttpApi.get<App>(`brand/${brandId}`, null, cancelerContainer)
        return response
    }

    public static async renewMembership(accountId: number) {
        const cancelerContainer = getCancelerContainer('renewMembership')
        const response = await HttpApi.post<App>(`apps/${accountId}/renew-membership`, null, null, cancelerContainer)
        return response
    }

    public static async deleteAppUpdateById(appUpdateId: number) {
        const response = await HttpApi.delete<any>(`apps/update/${appUpdateId}/delete-by-id`, null, undefined, false)
        return response
    }

    public static async changeAppUpdatePriority(appUpdateId: number) {
        const response = await HttpApi.put<any>(`apps/update/${appUpdateId}/change-priority`, null)
        return response
    }

    public static async getAppsWithErrors() {
        return await HttpApi.get<Count>(`apps/count-with-errors`, null)
    }
}

